import { Navigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { routes } from "./all_routes";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="suite-center-message">
        <p className="text-muted">Chargement…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />;
  }

  return children;
}
